import { SubmittedDocument } from "~/types/SubmittedDocument";
import { AssignmentType } from "~/types/enums/AssignmentType.enum";
import { DocumentSubmissionType } from "~/types/enums/DocumentSubmissionType.enum";

export const useAllowChecklistForSubmission = (
  submittedDocument?: SubmittedDocument
): boolean | undefined => {
  if (
    submittedDocument?.classroomId == undefined &&
    submittedDocument?.checklistId != undefined
  ) {
    return true;
  }

  if (
    submittedDocument?.documentSubmissionType ==
    DocumentSubmissionType.keyWordOutline
  )
    return false;

  if (
    submittedDocument?.assignmentType != undefined &&
    submittedDocument.assignmentType == AssignmentType.general
  ) {
    return false;
  }

  if (
    submittedDocument?.documentSubmissionType ==
      DocumentSubmissionType.roughDraft &&
    submittedDocument?.assignmentRequireRoughDraftChecklist == undefined
  ) {
    return undefined;
  }

  if (
    submittedDocument?.documentSubmissionType ==
      DocumentSubmissionType.roughDraft &&
    submittedDocument?.assignmentRequireRoughDraftChecklist != undefined &&
    submittedDocument.assignmentRequireRoughDraftChecklist == false
  ) {
    return false;
  }

  if (
    submittedDocument?.assignmentType != undefined &&
    submittedDocument.assignmentType == AssignmentType.iewComposition
  ) {
    return true;
  }

  // If the submission is a final draft or unknown and we have a checklistId  we always show the checklist.
  if (
    submittedDocument?.documentSubmissionType == undefined ||
    submittedDocument.documentSubmissionType ==
      DocumentSubmissionType.finalDraft
  ) {
    if (submittedDocument?.checklistId != undefined) {
      return true;
    }
  }

  return undefined;
};
